import { render, staticRenderFns } from "./Credential.vue?vue&type=template&id=f35b2982&"
import script from "./Credential.vue?vue&type=script&lang=js&"
export * from "./Credential.vue?vue&type=script&lang=js&"
import style0 from "./Credential.vue?vue&type=style&index=0&id=f35b2982&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports